import { ALERT_DEFINITIONS } from "./alertDefinitions";

export function crossChainAssetAlert(allChainsData, activeChain) {
  const chainsWithAssets = allChainsData.filter(
    (c) => c.tokens && c.tokens.length > 0
  );

  const otherChains = chainsWithAssets.filter(
    (c) => c.chain !== activeChain
  );

  if (otherChains.length > 0) {
    return {
      ...ALERT_DEFINITIONS.WRONG_NETWORK,
      detected: true,
      chains: otherChains.map((c) => c.chain),
    };
  }

  return {
    ...ALERT_DEFINITIONS.WRONG_NETWORK,
    detected: false,
  };
}
